import React from "react";
import styles from "./MainValue.module.scss";

export enum MainValueTextColor {
	Red = "red",
	Standard = "standard",
}

export enum MainValueTextSize {
	Standard = "standard-size",
	Large = "large",
}

interface MainValueProps {
	value: number | string | null | undefined;
	unit: string;
	textColor?: MainValueTextColor;
	textSize?: MainValueTextSize;	
}

export const MainValue: React.FC<MainValueProps> = ({ value, unit, textColor = MainValueTextColor.Standard, textSize = MainValueTextSize.Standard }) => {
	return (
		<span className={`${styles.mainValue} ${styles[textColor]} ${styles[textSize]}`}>
			{value != null ? <>{value} <small>{unit}</small></> : "N/A"}
		</span>
	);
};
